module.exports = __webpack_public_path__ + "img/KM.b3ced5c1.png";